"use client";

import { useSetQuantity } from "@trydig/centra/client";
import { clsx } from "@trydig/ui";
import styles from "./QuantityCounter.module.css";

interface IQuantityCounterProps {
	quantity?: number;
	line?: string;
	max?: number;
	min?: number;
	disabled?: boolean;
}

export const QuantityCounter = ({
	quantity: cartItemQuantity,
	line,
	disabled = false,
}: IQuantityCounterProps) => {
	const { mutate: updateQuantity } = useSetQuantity({
		optimistic: true,
	});

	if (!line || !cartItemQuantity) return null;

	const increaseQuantity = () => {
		updateQuantity({
			line,
			quantity: (cartItemQuantity || 0) + 1,
		});
	};

	const decreaseQuantity = () => {
		updateQuantity({
			line,
			quantity: (cartItemQuantity || 0) - 1,
		});
	};

	return (
		<div
			className={`${styles["yarn-quantity"]} ${disabled ? styles["yarn-quantity-disabled"] : ""} `}
		>
			<div className={styles["quantity-input"]}>
				<label htmlFor="quantity" style={{ display: "none" }}>
					Antall
				</label>

				<button
					disabled={disabled}
					className={clsx(
						styles["quantity-button"],
						cartItemQuantity === 0 && styles["disabled-button"],
					)}
					onClick={decreaseQuantity}
				>
					-
				</button>

				<span>{cartItemQuantity}</span>

				<button
					disabled={disabled}
					className={clsx(styles["quantity-button"])}
					onClick={increaseQuantity}
				>
					+
				</button>
			</div>
		</div>
	);
};
